export const dict = {
  es: {
    home: "Inicio", tours: "Excursiones", contact: "Contacto", admin: "Admin", search: "Buscar excursiones...",
    offer: "¡Oferta!", moreInfo: "Más Información", payNow: "Pagar Ahora", perPerson: "por persona",
    viewAll: "Ver todas las excursiones", toursCount: "tours", sendMessage: "Enviar Mensaje",
    yourName: "Tu nombre", yourEmail: "Tu correo electrónico", yourMessage: "Tu mensaje",
    namePh: "Escribe tu nombre", emailPh: "tucorreo@ejemplo.com", messagePh: "Escribe tu mensaje aquí...",
    quickLinks: "Enlaces Rápidos", location: "Ubicación", villas: "Reservación de Villas", rights: "Todos los derechos reservados.",
    whatsappAvailable: "WhatsApp disponible", moreInfoBtn: "MÁS Información", cart: "Carrito", followUs: "Síguenos",
    all: "Todos", noResults: "No se encontraron excursiones",
  },
  en: {
    home: "Home", tours: "Excursions", contact: "Contact", admin: "Admin", search: "Search excursions...",
    offer: "Sale!", moreInfo: "More Info", payNow: "Pay Now", perPerson: "per person",
    viewAll: "View all excursions", toursCount: "tours", sendMessage: "Send Message",
    yourName: "Your name", yourEmail: "Your email", yourMessage: "Your message",
    namePh: "Type your name", emailPh: "you@example.com", messagePh: "Type your message here...",
    quickLinks: "Quick Links", location: "Location", villas: "Villa Rentals", rights: "All rights reserved.",
    whatsappAvailable: "WhatsApp available", moreInfoBtn: "MORE Info", cart: "Cart", followUs: "Follow us",
    all: "All", noResults: "No excursions found",
  },
};
